/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipperCountry } from '../../models/shipper-country';

export interface MgmtShipperControllerGetLegacyShipperCountries$Params {
  shipperId: number;
  countryId: number;
}

export function mgmtShipperControllerGetLegacyShipperCountries(http: HttpClient, rootUrl: string, params: MgmtShipperControllerGetLegacyShipperCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShipperCountry>>> {
  const rb = new RequestBuilder(rootUrl, mgmtShipperControllerGetLegacyShipperCountries.PATH, 'get');
  if (params) {
    rb.query('shipperId', params.shipperId, {});
    rb.query('countryId', params.countryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ShipperCountry>>;
    })
  );
}

mgmtShipperControllerGetLegacyShipperCountries.PATH = '/api/mgmt/shippers/legacy-shippers-countries';
